import * as yup from "yup";
import { NoLeadingOrTrailingSpaces } from "../../lib/schemata";

export const otpSchema = yup.object().shape({
  otpEmail: yup.string().required("Required").test(NoLeadingOrTrailingSpaces),
});
